import { render, staticRenderFns } from "./week.vue?vue&type=template&id=86f37ab4&scoped=true&"
import script from "./week.vue?vue&type=script&lang=js&"
export * from "./week.vue?vue&type=script&lang=js&"
import style0 from "./week.vue?vue&type=style&index=0&id=86f37ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f37ab4",
  null
  
)

export default component.exports